import { ChevronLeftFilled } from "@fluentui/react-icons";
import { useNavigate } from "react-router-dom";

interface IGoBackProps {
  onBack?: () => void;
  label?: React.ReactNode;
  containerClass?: string;
}

const GoBack: React.FC<IGoBackProps> = ({
  onBack,
  label = "",
  containerClass,
}) => {
  const navigate = useNavigate();
  return (
    <div
      className={`my-4 cursor-pointer ${containerClass}`}
      onClick={() => {
        !!onBack ? onBack() : navigate("/");
      }}
    >
      {" "}
      <ChevronLeftFilled fontSize={32} className="pb-[2px]" />
      <>{label}</>
    </div>
  );
};

export default GoBack;
